module.exports = __webpack_public_path__ + "static/media/BrandonGrotesque-Bold.0beffbf4.otf";